import { menuAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle, } from '@chakra-ui/styled-system';
import { ThemeColorVariable, ThemeFontSizeVariable, ThemeShadowVariable, ThemeSpaceVariable, } from '../../theme-types';
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);
const baseItemStyle = defineStyle({
    minW: '280px',
    alignItems: 'center',
    paddingLeft: ThemeSpaceVariable.Medium,
    paddingRight: ThemeSpaceVariable.Medium,
    paddingTop: ThemeSpaceVariable.Small,
    paddingBottom: ThemeSpaceVariable.Small,
    color: ThemeColorVariable.OnSurface,
    backgroundColor: ThemeColorVariable.Surface,
    cursor: 'pointer',
    _hover: {
        backgroundColor: ThemeColorVariable.AccentHoverAlpha,
        textDecoration: 'underline',
        _disabled: {
            textDecoration: 'none',
            backgroundColor: 'transparent',
        },
    },
    _focus: {
        backgroundColor: ThemeColorVariable.AccentHoverAlpha,
        textDecoration: 'underline',
        _disabled: {
            textDecoration: 'none',
            backgroundColor: 'transparent',
        },
    },
    // Seems to be the only way to override the default margin of the icon (left)
    '.chakra-menu__icon-wrapper': {
        mr: ThemeSpaceVariable.XSmall,
    },
});
const baseListStyle = defineStyle({
    boxShadow: ThemeShadowVariable.Medium,
    bg: ThemeColorVariable.Surface,
    border: 'none',
    borderRadius: ThemeSpaceVariable.Small,
});
const baseCommandStyle = defineStyle({
    opacity: 1,
    color: ThemeColorVariable.OnSurfaceSubdued,
    fontSize: ThemeFontSizeVariable.Small,
    mx: ThemeSpaceVariable.XSmall,
});
const baseStyle = definePartsStyle({
    item: baseItemStyle,
    list: baseListStyle,
    command: baseCommandStyle,
});
export const menuConfig = defineMultiStyleConfig({
    baseStyle,
});
//# sourceMappingURL=menu-theme.js.map